(function () {
  var config = window.__marketAwareLinks || {};
  if (!config || config.enabled === false) return;

  function trimSlash(value) {
    return String(value || "").replace(/\/+$/, "") || "/";
  }

  function toUrl(value) {
    if (!value) return null;
    try {
      return new URL(value, window.location.origin);
    } catch (_) {
      return null;
    }
  }

  function normalizePath(value) {
    var url = toUrl(value);
    if (!url) return "";
    return trimSlash(url.pathname);
  }

  var aliasPath = normalizePath(config.aliasUrl);
  var usUrl = toUrl(config.usUrl);
  var euUrl = toUrl(config.euUrl);
  var aliasRedirectEnabled = config.redirectAliasPage !== false;

  if (!aliasPath || !usUrl || !euUrl) return;

  function splitList(value) {
    return String(value || "")
      .split(/[,;\n|]+/)
      .map(function (item) { return item.trim().toLowerCase(); })
      .filter(Boolean);
  }

  var euMarketHandles = splitList(config.euMarketHandles);
  var euCountries = splitList(config.euCountries);
  if (!euCountries.length) {
    euCountries = [
      "at", "be", "bg", "hr", "cy", "cz", "dk", "ee", "fi", "fr", "de", "gr",
      "hu", "ie", "it", "lv", "lt", "lu", "mt", "nl", "pl", "pt", "ro", "sk",
      "si", "es", "se", "is", "li", "no", "ch", "gb", "uk"
    ];
  }

  function getTargetUrl() {
    var marketHandle = String(config.currentMarketHandle || "").toLowerCase();
    var countryCode = String(config.currentCountryCode || "").toLowerCase();

    if (marketHandle && euMarketHandles.indexOf(marketHandle) !== -1) {
      return euUrl;
    }

    if (!euMarketHandles.length && countryCode && euCountries.indexOf(countryCode) !== -1) {
      return euUrl;
    }

    return usUrl;
  }

  function hrefMatchesAlias(rawHref) {
    var url = toUrl(rawHref);
    if (!url || url.origin !== window.location.origin) return false;
    return trimSlash(url.pathname) === aliasPath;
  }

  function resolveHref(rawHref) {
    var source = toUrl(rawHref);
    if (!source || !hrefMatchesAlias(source.href)) return "";

    var target = new URL(getTargetUrl().href);
    if (source.search && !target.search) target.search = source.search;
    if (source.hash && !target.hash) target.hash = source.hash;
    return target.href;
  }

  function rewriteLink(link) {
    if (!link || typeof link.getAttribute !== "function") return;
    var rawHref = link.getAttribute("href") || "";
    if (!hrefMatchesAlias(rawHref)) return;

    var resolvedHref = resolveHref(rawHref);
    if (!resolvedHref) return;

    if (!link.hasAttribute("data-market-aware-original-href")) {
      link.setAttribute("data-market-aware-original-href", rawHref);
    }
    link.setAttribute("href", resolvedHref);
    link.setAttribute("data-market-aware-resolved", "true");
  }

  function rewriteLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches("a[href]")) rewriteLink(scope);
    scope.querySelectorAll("a[href]").forEach(rewriteLink);
  }

  function redirectAliasPage() {
    if (!aliasRedirectEnabled) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (!hrefMatchesAlias(window.location.href)) return;

    var target = resolveHref(window.location.href);
    if (!target || target === window.location.href) return;
    window.location.replace(target);
  }

  function scheduleRewrite(root) {
    rewriteLinks(root || document);
    requestAnimationFrame(function () {
      rewriteLinks(root || document);
    });
  }

  document.addEventListener("click", function (event) {
    var target = event.target;
    var link = target && target.closest ? target.closest("a[href]") : null;
    if (!link) return;
    rewriteLink(link);
  }, true);

  document.addEventListener("shopify:section:load", function (event) {
    scheduleRewrite(event.target || document);
  });

  document.addEventListener("theme:page:mounted", function (event) {
    scheduleRewrite(event.detail && event.detail.container ? event.detail.container : document);
  });

  window.addEventListener("theme:barba:after-render", function (event) {
    scheduleRewrite(event.detail && event.detail.container ? event.detail.container : document);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scheduleRewrite(document);
      redirectAliasPage();
    }, { once: true });
  } else {
    scheduleRewrite(document);
    redirectAliasPage();
  }

  window.__marketAwareLinksRefresh = scheduleRewrite;
})();
